import axios from 'axios'
import { EnumResponse } from '@/api/services/common.dto'

import { Nullable } from '@/shared/types/app.types'

export default class ShipmentRulesAuxiliaryService {
    async getAllPortionsInternalStatesByLaboratory(laboratoryId: Nullable<number>): Promise<EnumResponse[]> {
        const params = { laboratoryId }
        const response = await axios.get<EnumResponse[]>(`/configuration/allowedStatesForRules/portions`, { params })
        return response.data
    }
    async getAllSamplesInternalStatesByLaboratory(laboratoryId: Nullable<number>): Promise<EnumResponse[]> {
        const params = { laboratoryId }
        const response = await axios.get<EnumResponse[]>(`/configuration/allowedStatesForRules/samples`, { params })
        return response.data
    }
    async getAllSubportionsInternalStatesByLaboratory(laboratoryId: Nullable<number>): Promise<EnumResponse[]> {
        const params = { laboratoryId }
        const response = await axios.get<EnumResponse[]>(`/configuration/allowedStatesForRules/subportions`, { params })
        return response.data
    }
}

export const shipmentRulesAuxiliaryService = new ShipmentRulesAuxiliaryService()
